import React from "react";
import { createRoot } from "react-dom/client";
import "@shared/styles/index.styles.css";
import { DataContextProvider } from "@shared/context/Data";
import { AvailableLanguages } from "@shared/types";
import App from "./components/App";
const locales = {
    [AvailableLanguages.English]: () => import("./locales/en.json")
};
const initApp = () => {
    const container = document.getElementById("root");
    const root = createRoot(container);
    root.render(React.createElement(DataContextProvider, { locales: locales },
        React.createElement(App, null)));
};
initApp();
